import styled from '@emotion/styled';

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => (props.showError ? '#ff4d4f' : '#f0f0f0')};
  border-radius: 4px;
  padding: 8px;
  text-align: center;
  margin-top: 8px;

  @media (min-width: 992px) {
    margin-top: 0px;
  }
`;

export const LabelText = styled.h3`
  font-size: 12px;
  line-height: 1.25;
  color: ${props => (props.showError ? '#ffffff' : '#9b9b9b')};
  margin: 4px 8px;
  text-align: center;

  @media (min-width: 414px) {
    font-size: 14px;
  }

  @media (min-width: 992px) {
    font-size: 16px;
  }
`;
